import React, { Component } from 'react';
import { Element } from 'react-scroll';
import { observer } from 'mobx-react';

// From Elements folder
import {
  HeadingOne,
  Text
} from '../../elements';

// Import from Style
import {
  Wrapper,
  Section,
  SpecialInset,
  HeadingOneSpecial,
} from './style';

// Import other Components
import ScrollProgress from '../ScrollProgress';
import ScrollPrompt from '../ScrollPrompt';
import Navigation from '../Navigation';
import ShareButtons from '../ShareButtons';
import ScrollingList from '../ScrollingList';
import EditorialList from '../EditorialList';
import NavUpdater from '../NavUpdater';

import AppState from '../../states/AppState';
import ListsState from '../../states/ListsState';

class Body extends Component {
  render() {
    const { data } = AppState;
    const { lists } = ListsState;

    return (
      <Wrapper>
        <ScrollProgress />
        <ScrollPrompt />
        <Navigation />
        <ShareButtons />

        <NavUpdater navItemIndex={0}>
          <Section name="Introduction">
            <HeadingOneSpecial>{data.sections.intro.heading}</HeadingOneSpecial>
            <SpecialInset>
              <Text
                dangerouslySetInnerHTML={{
                  __html: data.sections.intro.text
                }}
              />
            </SpecialInset>
          </Section>
        </NavUpdater>

        {lists.map((list, listIndex) => {
          if (!list.appearsInBody) return null;
          return list.type === 'slider' ? (
            <NavUpdater key={listIndex} navItemIndex={listIndex + 1}>
              <Section name={list.navHeading}>
              { /*
                Disable to see how this affects performance
                <ScrollingList list={list} listIndex={listIndex} />
                */
              }
              <ScrollingList list={list} listIndex={listIndex} />
              </Section>
            </NavUpdater>
          ) : list.type === 'editorial' ? (
            <NavUpdater key={listIndex} navItemIndex={listIndex + 1}>
              <Section name={list.navHeading}>
                <EditorialList list={list} listIndex={listIndex} />
              </Section>
            </NavUpdater>
          ) : null;
        })}
      </Wrapper>
    );
  }
}

export default observer(Body);



// WEBPACK FOOTER //
// ./src/components/Body/index.js